// extracted by mini-css-extract-plugin
export default {"container":"uga-z","mediaElement":"vga-z","close":"wga-z"};